import React, { useState } from 'react';
import './PdfUpload.css';

const PdfUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      setSelectedFile(file);
      setUploadStatus('');
    } else if (file) {
      setUploadStatus('Please select a PDF file');
      setSelectedFile(null);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!selectedFile) {
      setUploadStatus('Please select a PDF file first');
      return;
    }

    setIsUploading(true);
    setUploadStatus('Uploading and processing PDF...');

    const formData = new FormData();
    formData.append('pdf', selectedFile);

    try {
      const response = await fetch('http://localhost:5000/api/upload-pdf', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();
      console.log('Response from server:', data);

      if (data.success) {
        setUploadStatus(data.message);
        setSelectedFile(null);
        // Reset file input
        document.getElementById('pdfFile').value = '';
      } else {
        setUploadStatus(data.error || 'Upload failed');
      }
    } catch (error) {
      setUploadStatus('Error uploading file. Please try again.');
      console.error('Upload error:', error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="pdf-upload-container">
      <div className="pdf-upload-card">
        <h1>Upload PDF to Pinecone</h1>
        <p className="upload-description">
          Upload a PDF file to extract its content and store it in Pinecone for AI-powered search and retrieval.
        </p>
        
        <form onSubmit={handleSubmit} className="upload-form">
          <div className="form-group">
            <label htmlFor="pdfFile" className="file-input-label">
              <div className="file-input-content">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="17 8 12 3 7 8"></polyline>
                  <line x1="12" y1="3" x2="12" y2="15"></line>
                </svg>
                <span>
                  {selectedFile ? selectedFile.name : 'Choose PDF file'}
                </span>
              </div>
              <input
                type="file"
                id="pdfFile"
                name="pdf"
                accept=".pdf"
                onChange={handleFileChange}
                className="file-input"
                required
              />
            </label>
          </div>

          <button 
            type="submit" 
            className="upload-button"
            disabled={isUploading || !selectedFile}
          >
            {isUploading ? (
              <>
                <span className="spinner"></span>
                Processing...
              </>
            ) : (
              'Upload PDF'
            )}
          </button>
        </form>

        {uploadStatus && (
          <div className={`status-message ${uploadStatus.includes('successfully') ? 'success' : uploadStatus.includes('Error') ? 'error' : ''}`}>
            {uploadStatus}
          </div>
        )}

        <div className="upload-info">
          <h3>How it works:</h3>
          <ol>
            <li>Select a PDF file (max 10MB)</li>
            <li>Click "Upload PDF"</li>
            <li>The system will extract text from your PDF</li>
            <li>Text is split into chunks and converted to embeddings</li>
            <li>Embeddings are stored in Pinecone for AI search</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default PdfUpload;